<template>
    <router-view></router-view>
</template>

<script>
  export default {
    name: 'app',
    beforeCreate () {
      this.$store.dispatch('getDecoders')
    }
  }
</script>

<style lang="scss">
    .VuePagination {
        text-align: center;
    }
</style>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/App.vue